import { Fragment, useCallback, useState } from 'react'
import toast from 'react-hot-toast'

import { TableOption, TableOptions } from 'Design/components/Table'
import ConfirmationModal from 'Design/components/ConfirmationModal'

import parseErrorMessage from 'Utils/error-message-parser'

import { useDeleteTokenMutation } from '../rest-api.service'

const APITokenOptions = (props) => {
  const { id, onEditToken } = props

  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const [deleteToken, deleteTokenResult] = useDeleteTokenMutation()

  const handleDeleteToken = useCallback(() => {
    const promise = deleteToken(id).unwrap()
    toast.promise(promise, {
      loading: 'Deleting Token...',
      success: 'API Token deleted successfully.',
      error: parseErrorMessage('Unable to delete token. Try again...')
    })

    promise.then(handleCloseModal)
  }, [deleteToken, id])

  const handleEditClick = () => {
    onEditToken(id)
  }

  const handleOpenModal = () => {
    setShowDeleteModal(true)
  }

  const handleCloseModal = () => {
    setShowDeleteModal(false)
  }

  const isLoading = deleteTokenResult.isLoading

  return (
    <Fragment>
      <ConfirmationModal
        isOpen={showDeleteModal}
        title='Delete Token'
        description='Are you sure to delete this token?'
        onCloseButtonClick={handleCloseModal}
        onConfirmButtonClick={handleDeleteToken}
        confirmButtonText='Yes'
        cancelButtonText='No'
        disableConfirmButton={isLoading}
      />
      <TableOptions>
        <TableOption onClick={handleEditClick}>Edit</TableOption>
        <TableOption onClick={handleOpenModal}>Delete</TableOption>
      </TableOptions>
    </Fragment>
  )
}

export default APITokenOptions
